import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";

import {mobVideos, desVideos, isMobile} from "../service/media";

Vue.use(Vuex);

// const baseUrl = "http://localhost:3501/";
// const baseUrl = "http://127.0.0.1:8000/api/";
const baseUrl = "http://66.97.38.151:81/api/";
Axios.defaults.baseURL = baseUrl;

export default new Vuex.Store({
    // strict: true, /* <----- SOLO DEBUG - ELIMINAR EN PRODUCCION!!!! */
    /* modules: {
       nav: NavModule
     },*/
    state: {
        products: [],
        selectedProduct: {},
        desktopVideos: desVideos,
        mobileVideos: mobVideos,
        categories: [],
        parameters: []
    },
    mutations: {
        saveProduct(currentState, product) {
            let index = currentState.products.findIndex(
                p => p.slug == product.slug
            );
            if (index == -1) {
                currentState.products.push(product);
            } else {
                Vue.set(currentState.products, index, product);
            }
        },
        saveCategory(currentState, category) {
            currentState.categories.push(category);
        },
        saveParameter(currentState, parameter) {
            currentState.parameters.push(parameter);
        },
        selectProduct(currentState, product) {
            currentState.selectedProduct = product;
        }
    },
    getters: {
        orderedProducts(state) {
            return state.products.concat().sort((p1, p2) => p1.eslora_prfv - p2.eslora_prfv);
        },
        filteredProducts(state, getters) {
            return category => getters.orderedProducts.filter(p => {
                if (p.category != null)
                    return p.category.name_en.toLowerCase() == category.toLowerCase()
            })
        },
        respRandomVideo(state) {
            let iMob = Math.floor(Math.random() * state.mobileVideos.length);
            let iDes = Math.floor(Math.random() * state.desktopVideos.length);
            return isMobile() ? state.mobileVideos[iMob] : state.desktopVideos[iDes];
        },
        orderedCategories(state) {
            return state.categories.concat().sort((p1, p2) => p1.name_es - p2.name_es);
        },
        getParameterValueByKey(state) {
            return key => state.parameters.find(p => p.key == key)
        }
    },
    actions: {
        getProductsAction(context) {
            Axios.get('ships/').then(resp =>
                resp.data.forEach(p => context.commit("saveProduct", p))
            )
        },
        getCategoriesAction(context) {
            Axios.get('categories/').then(resp =>
                resp.data.forEach(cat => context.commit("saveCategory", cat))
            )
        },
        getParametersAction(context) {
            Axios.get('params/apps/').then(resp =>
                resp.data.forEach(param => context.commit("saveParameter", param))
            )
        }
    }
});